module.exports = __webpack_public_path__ + "img/L20124.3355e751.png";